import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { noCapMap } from '../../../../../../utils';

const TestingPlan = ({ endpoints, isRunningTest, users, onEndpointComplete, completedCounter }) => {
  return <div id='testing-plan' className='boxed'>
    {
      noCapMap(
        (Endpoint, index) => {
          return <Endpoint key={index} isRunningTest={isRunningTest} users={users} onComplete={onEndpointComplete} />
        }
      )(endpoints)
    }
  </div>
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      completedCounter: 0
    },
    {
      onEndpointComplete: ({ completedCounter }) => () => ({
        completedCounter: completedCounter + 1
      }),
      clearCompletedCounter: () => () => ({
        completedCounter: 0
      })
    }
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        isRunningTest,
        endpoints,
        completedCounter,
        onComplete,
        clearCompletedCounter
      } = this.props

      if (completedCounter > prevProps.completedCounter) {
        if ((completedCounter === endpoints.length) && isRunningTest) {
          clearCompletedCounter()
          onComplete()
        }
      }
    }
  })
)(TestingPlan)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/components/testingPlan.js